import React, { Component } from 'react';
import $ from 'jquery'
import contactlogic from '../js/contact_me';
class Contact extends Component {

    componentDidMount() {

        (function(){
            window.emailjs.init("user_Shec7MotJRQXPaOGiovxN");
         })();
    

        $(contactlogic);
        //console.log(window.location)
        /*When clicking on Full hide fail/success boxes */
        $('#name').focus(function () {
            $('#success').html('');
        });

    }

    render() {
        return (

            <form id="contactForm" name="sentMessage" noValidate>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <input className="form-control" id="name" type="text" name="name" placeholder="Il tuo nome *" required data-validation-required-message="Inserisci il tuo nome." />
                            <p className="help-block text-danger">
                            </p></div>
                        <div className="form-group">
                            <input className="form-control" id="email" type="email" name="email" placeholder="La tua mail *" required data-validation-required-message="Inserisci il tuo indirizzo email." />
                            <p className="help-block text-danger">
                            </p></div>
                        <div className="form-group">
                            <input className="form-control" id="phone" type="tel" name="phone" placeholder="Il tuo telefono *" required data-validation-required-message="Inserisci il tuo numero di teleono." />
                            <p className="help-block text-danger">
                            </p></div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <textarea className="form-control" id="message" name="message" placeholder="Il tuo messaggio *" required data-validation-required-message="Inserisci il tuo messaggio."></textarea>
                            <p className="help-block text-danger"></p>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="col-lg-12 text-center">
                        <div id="success"></div>
                        <button id="sendMessageButton" className="btn btn-primary btn-xl text-uppercase" type="submit">Invia</button>
                    </div>
                </div>
            </form>
        );
    }
};
export default Contact